import {defineNuxtPlugin} from '#app';

export default defineNuxtPlugin(() => {
    // Load polyfill only if not supported
    if (typeof CSS !== 'undefined' && (!CSS.supports || !CSS.supports('container-type', 'inline-size'))) {
        // @ts-expect-error this is not typed
        import('container-query-polyfill');
    }
});
